import React from "react";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { TextareaAutosize } from "@material-ui/core";
// import DateTime from "react-datetime";

import "rc-slider/assets/index.css";
import "react-datetime/css/react-datetime.css";
import "react-datepicker/dist/react-datepicker.css";
const hiddenFileInput = React.createRef(null);

//const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

class Activity extends React.Component {
  initialState = {
    nombre: "",
    objetivo: "",
    evento_tipo_id: "",
    evento_sitio_id: "",
    fecha: new Date().toISOString().slice(0, 10),
    hora: new Date().getTime(),
    lugar: "",
    nivelUsuario: localStorage.nivel_actual,
    cant_mujeres: "",
    cant_hombres: "",
    procesando: false,
    evento_participacion_id: "",
    option_evento_tipo: Api.loadCatalogue("cat_evento_tipo"),
    option_evento_sitio: Api.loadCatalogue("cat_evento_sitio"),
    option_evento_rol: Api.loadCatalogue("cat_evento_participacion"),
    documentos: [],
    document_type_temp: 0,
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;

    // var minYesterday = DateTime.moment().subtract(1, "day");
    this.handleFile = this.handleFile.bind(this);
    this.handleChangeFecha = this.handleChangeFecha.bind(this);
    this.handleChangeHora = this.handleChangeHora.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleReporte = this.handleReporte.bind(this);
    this.handleCantHombres = this.handleCantHombres.bind(this);
    this.handleCantMujeres = this.handleCantMujeres.bind(this);
    this.valPositiveNumber = this.valPositiveNumber.bind(this);
  }

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }
  }

  handleDateChange = (date) => {
    //setSelectedDate(date);
  };

  handleChangeFecha(e) {
    this.setState({ fecha: e.target.value });
  }

  handleChangeHora(e) {
    this.setState({ hora: e.target.value });
  }

  handleFile(e) {
    let file = e.files;
    let validExts = ["jpg", "jpeg", "png", "pdf"];
    let ext = file[0].type.split("/")[1];

    if (this.state.documentos.length === 0) {
      //no se puede añadir mas de un archivo
      if (validExts.includes(ext)) {
        let imgReader = new FileReader();
        imgReader.react = this;

        let _react = this.state;

        imgReader.onloadend = function () {
          let dx = {
            data: imgReader.result,
            ext: ext,
            file: file[0].name,
            key: _react.documentos.length,
          };

          _react.documentos[_react.documentos.length] = dx;

          this.react.setState({
            documentos: _react.documentos,
          });

          this.react = null;
          e.value = null;
        };
        imgReader.readAsDataURL(file[0]);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error...",
          text: "Tipo de documento no válido.",
        });
        e.value = null;
        return;
      }
    }
  }

  handleDelete(e) {
    let docs = [...this.state.documentos];

    Swal.fire({
      title: "Eliminar documento",
      text: "Esta acción eliminará el documento seleccionado de la carga.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Regresar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        docs.splice(e.target.id, 1);

        this.setState({
          documentos: docs,
        });

        //this.setState({ recs: document.querySelectorAll("i.text-success").length, });
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ procesando: true });

    if (this.state.documentos.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "Subir documento de soporte.",
      });
      this.setState({ procesando: false });
      //e.value = null;
      return;
    }

    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };
    // shallow copy is inherit of the main state
    delete postData.option_evento_tipo;
    delete postData.option_evento_sitio;
    delete postData.option_evento_rol;

    //

    Api.fetch("app/registroActividad", postData, "POST")
      .then((data) => this.handleRegister(data))
      .catch((error) => {
        error.json().then((message) => {
          this.setState({ procesando: false });
          Swal.fire({
            title: "Ocurrió un error al procesar la actividad",
            icon: "error",
            text: "Revise la información e intente de nuevo su última acción", //message,
          });
        }); //catching errors to show notification
      });
  }

  handleRegister(e) {
    if (e.errors) {
      //|| e.exception
      let tplErrors = `Los siguientes campos son obligatorios: <u>`;

      /* for (let err in e.errors) {
          let errorMessage = e.errors[err].toString();
          //let errox = errorMessage.split(",");
          
          errorMessage = errorMessage.replace("_id", "");
          errorMessage = errorMessage.replace("_", " ");
          errorMessage = errorMessage.replace("id", "");

          errorMessage = errorMessage.replace("nombre", "tema");
          errorMessage = errorMessage.replace("evento tipo", "tipo de evento");
          errorMessage = errorMessage.replace("evento sitio", "tipo de sitio");
          errorMessage = errorMessage.replace("evento participacion", "participación en el evento");
          errorMessage = errorMessage.replace("cant hombres", "cantidad de hombres");
          errorMessage = errorMessage.replace("cant mujeres", "cantidad de mujeres");

        tplErrors += `<li>${errorMessage
         //  .replace("_id", "")
         // .replace("_", " ") 
          .toUpperCase()}</li>`;
      } */

      for (let err in e.errors) {
        tplErrors += `<li>${err
          .replace("_id", "")
          .replace("_", " ")
          .replace("nombre", "tema")
          .replace("evento tipo", "tipo de evento")
          .replace("evento sitio", "tipo de sitio")
          .replace("evento participacion", "participación en el evento")
          .replace("cant hombres", "cantidad de hombres")
          .replace("cant mujeres", "cantidad de mujeres")
          .toUpperCase()}</li>`;
      }

      tplErrors += `</u>`;

      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
      this.setState({ procesando: false });
      return false;
    } else {
      Swal.fire({
        title: "Actividad registrada",
        icon: "success",
        text: "Su actividad ha sido registrada exitosamente.",
      }).then(() => {
        window.location = "/actividades/lista";
      });
    }

    this.setState({ procesando: false });
  }

  handleReporte() {
    Api.loading(true);

    Api.fetch("app/getReporte").then((data) => {
      Api.loading(false);
      Api.notify(data.message);
    });
  }

  handleCantHombres(evt) {
    if (this.valPositiveNumber(evt.target.value)) {
      this.setState({ cant_hombres: evt.target.value });
    }
  }

  handleCantMujeres(evt) {
    if (this.valPositiveNumber(evt.target.value)) {
      this.setState({ cant_mujeres: evt.target.value });
    }
  }

  valPositiveNumber(char) {
    let regex = /^([0]?|[1-9]+[0]*)$/;
    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/form/elements">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            {/*<Link to="/actividades">Actividades</Link>*/}
            Actividades
          </li>
          <li className="breadcrumb-item active">Registro</li>
        </ol>

        <h1 className="page-header">Registro de actividad</h1>

        <div className="row" onSubmit={this.handleSubmit}>
          <div className="col-md-12" /*  style={{ left: "10%" }} */>
            <Panel>
              <PanelBody>
                <form style={{ margin: "2.5%" }}>
                  <div className="row">
                    {/*<div className="form-group col-md-12">
                      <button
                        //type=""
                        onClick={this.handleReporte}
                        className="btn btn-info col-md-2 float-right"
                      >
                        Enviar reporte
                      </button>
                    </div>*/}
                    <div className="form-group col-md-12">
                      <label>Tema: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="nombre"
                        value={this.state.nombre}
                        autoComplete="off"
                        onChange={(e) =>
                          this.setState({
                            nombre: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        required
                      />
                    </div>

                    <div className="form-group col-md-12">
                      <label>Objetivo: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="objetivo"
                        value={this.state.objetivo}
                        autoComplete="off"
                        onChange={(e) =>
                          this.setState({
                            objetivo: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                        required
                      />
                      {/* 
                      <input
                        type="text"
                        name="objetivo"
                        value={this.state.objetivo}
                        autoComplete="off"
                        onChange={(e) =>
                          this.setState({
                            objetivo: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        required
                      /> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Tipo de evento: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="evento_tipo_id"
                        className="form-control m-b-5"
                        value={this.state.evento_tipo_id}
                        onChange={(e) =>
                          this.setState({
                            evento_tipo_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.option_evento_tipo.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Tipo de sitio: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="evento_sitio_id"
                        className="form-control m-b-5"
                        value={this.state.evento_sitio_id}
                        onChange={(e) =>
                          this.setState({
                            evento_sitio_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.option_evento_sitio.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Lugar: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="lugar"
                        value={this.state.lugar}
                        autoComplete="off"
                        onChange={(e) =>
                          this.setState({
                            lugar: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Fecha: </label>
                      <span className="text-danger"> *</span>

                      <input
                        type="date"
                        name="fecha"
                        onChange={this.handleChangeFecha}
                        id="fecha"
                        value={this.state.fecha}
                        className="form-control"
                        placeholder="Seleccione"
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Hora: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="time"
                        name="hora"
                        value={this.state.hora}
                        onChange={this.handleChangeHora}
                        className="form-control"
                        id="hora"
                        placeholder="Seleccione"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>No. de participantes hombres: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="cant_hombres"
                        value={this.state.cant_hombres}
                        autoComplete="off"
                        onChange={this.handleCantHombres}
                        className="form-control m-b-5"
                        required
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>No. de participantes mujeres: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="cant_mujeres"
                        value={this.state.cant_mujeres}
                        autoComplete="off"
                        onChange={this.handleCantMujeres}
                        className="form-control m-b-5"
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Participación en el evento: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="evento_participacion_id"
                        className="form-control m-b-5"
                        value={this.state.evento_participacion_id}
                        onChange={(e) =>
                          this.setState({
                            evento_participacion_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.option_evento_rol.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row col-md-6">
                    <label>Documento soporte: </label>

                    <div
                      className="col-md-6" /* style={{ marginTop: "0.5%" }} */
                    >
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={(e) => hiddenFileInput.current.click()}
                      >
                        Seleccionar archivo
                      </button>
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        ref={hiddenFileInput}
                        onChange={(e) => this.handleFile(e.target)}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>

                  <div className="row col-md-12">
                    {
                      <i>
                        *Los tipos extensión de los documentos que se admiten
                        son: ".jpg", ".jpeg", ".png" y ".pdf"{" "}
                      </i>
                    }
                  </div>

                  <div className="row">
                    {this.state.documentos.map((document, index) => (
                      <div
                        key={document.key}
                        data-tipo={document.type}
                        className="note note-primary documentoCargado"
                      >
                        <div className="note-icon">
                          <i
                            className={
                              document.ext === "pdf"
                                ? "fas fa-file-pdf"
                                : "fas fa-file-image"
                            }
                          ></i>
                        </div>
                        <div className="note-content">
                          <h4>
                            <b>{document.tipo}</b>
                          </h4>
                          <p> {document.file} </p>
                        </div>
                        <div className="pull-right">
                          <i
                            onClick={this.handleDelete}
                            id={index}
                            className="ion ion-md-close-circle fa-2x fa-fw pull-left m-r-10 text-red"
                          ></i>
                        </div>
                      </div>
                    ))}
                  </div>

                  <hr />

                  <div
                    className={
                      this.state.procesando
                        ? "progress rounded-corner m-b-15"
                        : "hide"
                    }
                  >
                    <div
                      className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                      style={{ width: "100%", height: "20px" }}
                    >
                      <h4>Cargando, espere...</h4>
                    </div>
                  </div>

                  <div
                    className={this.state.procesando ? "hide" : "pull-right"}
                  >
                    <div style={{ marginBottom: "10%" }}>
                      <button
                        type="reset"
                        onClick={this.handleReset}
                        className="btn btn-danger m-r-5"
                      >
                        Regresar
                      </button>
                      <button
                        type="submit"
                        onClick={this.handleSubmit}
                        className=" btn btn-success m-r-5"
                      >
                        Registrar
                      </button>
                    </div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default Activity;
